import React from 'react';
import { StyleProp, Text, View, ViewStyle } from 'react-native';
import i18n from 'i18n-js';

import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';

import { ColorFunction } from '@styles/colors/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import Svg from '@styles/icons/svg';
import SimpleButton from '@components/operatorPanel/components/elements/buttons/SimpleButton';
import { SimpleOnPress } from '@interfaces/base';

export interface SendToMachineButtonProps extends Partial<SimpleOnPress> {
  C: ColorFunction;
  scale: ScaleFunction;
  style?: StyleProp<ViewStyle>;
  font?: typeof initialFont;
  isNCFileSending: boolean;
}

const SendToMachineButton = ({ C, onPress, style, scale = initialScale, font = initialFont, isNCFileSending }: SendToMachineButtonProps) => {
  return (
    <SimpleButton C={C} style={style} scale={scale} onPress={onPress}>
      {!isNCFileSending && (
        <View style={{ alignItems: 'center', flexDirection: 'row', marginRight: scale(10), gap: scale(3) }}>
          <Svg transform={'rotate(180)'} icon="arrow" width={scale(8)} height={scale(7)} color={'Label/Light/Selected'} />
          <Svg icon="sendToMachine" width={scale(19)} height={scale(15)} color={'Label/Light/Selected'} />
        </View>
      )}

      <Text style={[font['Button 2'], { color: C('Label/Light/Selected') }]}>{i18n.t(isNCFileSending ? 'Sending...' : 'Send To Machine')}</Text>
    </SimpleButton>
  );
};

export default SendToMachineButton;
